import {
  StatusActiveGrey,
  StatusClosedGrey,
  StatusInactiveGrey
} from 'front-end/src/components/common/status/Status'
import React from 'react'

import { CampaignStateEnum } from '../../../../graphql/private/PrivateSchemaTypes'

const CampaignStatus = ({ status }: { status: CampaignStateEnum }) => {
  return status === CampaignStateEnum.DEACTIVATED ? (
    <StatusClosedGrey />
  ) : status === CampaignStateEnum.ACTIVE ? (
    <StatusActiveGrey />
  ) : (
    <StatusInactiveGrey />
  )
}

export default CampaignStatus
